export type TaskListViewState = 'loading' | 'empty' | 'list'

/**
 * Decide which of the three mutually exclusive task list views to render.
 *
 * A Zero query result type of `'unknown'` only means the server has not yet
 * confirmed the query is complete — it does *not* mean there is no data. On a
 * warm client cache the hook returns populated rows while the type is still
 * `'unknown'`, so loading alone is not enough to justify a skeleton: rendering
 * one would either stack it above already-visible rows or blank them out.
 * Whenever there is something to show, show it.
 */
export function resolveTaskListViewState({
  isLoading,
  itemCount,
}: {
  isLoading: boolean
  itemCount: number
}): TaskListViewState {
  if (itemCount > 0) return 'list'
  return isLoading ? 'loading' : 'empty'
}
